@if (lead) {
  <form novalidate [formGroup]="leadForm" (ngSubmit)="onSubmitForm()">
    <div class="columns">
      <div class="column">
        @if (lead.type === 'purchase') {
          <div class="mobile-row">
            <div class="field">
              <label class="label" for="rateType">Desired type of rate</label>
              <div class="control has-icons-left">
                <div class="select is-fullwidth">
                  <select formControlName="rateType" id="rateType">
                    @for (rateType of leadValues.rateTypes; track rateType) {
                      <option value="{{rateType.key}}">{{rateType.value}}</option>
                    }
                  </select>
                </div>
                <span class="icon is-left">
                  <i class="fas fa-tachometer-alt"></i>
                </span>
              </div>
            </div>
            @if (lead.type === 'purchase') {
              <div class="field">
                <label class="label" for="buyingProcess">Where are you in the buying process?</label>
                <div class="control has-icons-left">
                  <div class="select is-fullwidth">
                    <select formControlName="buyingProcess" id="buyingProcess" (change)="buyingProcessChange()">
                      @for (option of leadValues.buyingProcess; track option) {
                        <option value="{{option.key}}">{{option.value}}</option>
                      }
                    </select>
                  </div>
                  <span class="icon is-left">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
            }
          </div>
        }
        @if (lead.type === 'purchase') {
          <div class="field">
            <label class="label" for="purchasePrice">Purchase price of new home</label>
            <div class="control has-icons-left">
              <div class="select is-fullwidth">
                <select formControlName="purchasePrice" id="purchasePrice">
                  @for (purchasePrice of leadValues.purchasePrices; track purchasePrice) {
                    <option value="{{purchasePrice.key}}">{{purchasePrice.value}}</option>
                  }
                </select>
              </div>
              <span class="icon is-left">
                <i class="far fa-money-bill-alt"></i>
              </span>
            </div>
          </div>
        }
        @if (lead.type === 'refinance') {
          <div class="field">
            <label class="label" for="cashOut">Cash Out</label>
            <div class="control has-icons-left">
              <div class="select is-fullwidth">
                <select formControlName="cashOut" id="cashOut">
                  @for (cashOut of leadValues.cashOuts; track cashOut) {
                    <option value="{{cashOut.key}}">{{cashOut.value}}</option>
                  }
                </select>
              </div>
              <span class="icon is-left">
                <i class="far fa-money-bill-alt"></i>
              </span>
            </div>
          </div>
        }
        @if (lead.type === 'refinance') {
          <div class="field">
            <label class="label" for="propertyValue">Estimated Home Value</label>
            <div class="control has-icons-left">
              <div class="select is-fullwidth">
                <select formControlName="propertyValue" id="propertyValue">
                  @for (propertyValue of leadValues.propertyValues; track propertyValue) {
                    <option value="{{propertyValue.key}}">{{propertyValue.value}}</option>
                  }
                </select>
              </div>
              <span class="icon is-left">
                <i class="far fa-money-bill-alt"></i>
              </span>
            </div>
          </div>
        }
        @if (lead.type === 'refinance') {
          <div class="field">
            <label class="label" for="firstMortgageBalance">Total Mortgage Balance</label>
            <div class="control has-icons-left">
              <div class="select is-fullwidth">
                <select formControlName="firstMortgageBalance" id="firstMortgageBalance">
                  @for (firstMortgageBalance of leadValues.firstMortgageBalances; track firstMortgageBalance) {
                    <option value="{{firstMortgageBalance.key}}">{{firstMortgageBalance.value}}</option>
                  }
                </select>
              </div>
              <span class="icon is-left">
                <i class="far fa-money-bill-alt"></i>
              </span>
            </div>
          </div>
        }
        @if (lead.type === 'purchase') {
          <div class="field">
            <label class="label" for="downPayment">Estimated down payment</label>
            <div class="control has-icons-left">
              <div class="select is-fullwidth">
                <select formControlName="downPayment" id="downPayment">
                  @for (downPayment of leadValues.downPayments; track downPayment) {
                    <option value="{{downPayment.key}}">{{downPayment.value}}</option>
                  }
                </select>
              </div>
              <span class="icon is-left">
                <i class="far fa-money-bill-alt"></i>
              </span>
            </div>
          </div>
        }
        <div class="mobile-row">
          <div class="field">
            <label class="label" for="creditRating">Credit type</label>
            <div class="control has-icons-left">
              <div class="select is-fullwidth">
                <select formControlName="creditRating" id="creditRating">
                  @for (creditRating of leadValues.creditRatings; track creditRating) {
                    <option value="{{creditRating.key}}">{{creditRating.value}}</option>
                  }
                </select>
              </div>
              <span class="icon is-left">
                <i class="far fa-credit-card"></i>
              </span>
            </div>
          </div>
          <div class="field">
            <label class="label" for="veteranMilitary">Are you a veteran or active military?</label>
            <div class="control has-icons-left">
              <div class="select is-fullwidth">
                <select formControlName="veteranMilitary" id="veteranMilitary">
                  @for (yesNo of leadValues.yesNos; track yesNo) {
                    <option value="{{yesNo.key}}">{{yesNo.value}}</option>
                  }
                </select>
              </div>
              <span class="icon is-left">
                <i class="fas fa-flag"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="mobile-row">
          <div class="field">
            <label class="label" for="firstName">First Name</label>
            <div class="control has-icons-left">
              <input class="input" type="text" formControlName="firstName" id="firstName" autocomplete="given-name">
              <span class="icon is-left">
                <i class="fas fa-user"></i>
              </span>
              @if (firstNameControl.errors?.required) {
                <p class="help is-danger">First Name is required.</p>
              }
              @if (firstNameControl.errors?.minlength) {
                <p class="help is-danger">First Name must be at least {{ firstNameControl.errors.minlength.requiredLength }} letters.</p>
              }
            </div>
          </div>
          <div class="field">
            <label class="label" for="lastName">Last Name</label>
            <div class="control has-icons-left">
              <input class="input" type="text" formControlName="lastName" id="lastName" autocomplete="family-name">
              <span class="icon is-left">
                <i class="fas fa-user"></i>
              </span>
              @if (lastNameControl.errors?.required) {
                <p class="help is-danger">Last Name is required.</p>
              }
              @if (lastNameControl.errors?.minlength) {
                <p class="help is-danger">Last Name must be at least {{ lastNameControl.errors.minlength.requiredLength }} letters.</p>
              }
            </div>
          </div>
        </div>
        <div class="mobile-row">
          <div class="field">
            <label class="label" for="phone">Phone</label>
            <div class="control has-icons-left">
              <input class="input" type="phone" formControlName="phone" id="phone" [imask]="phoneMask" autocomplete="tel">
              <span class="icon is-left">
                <i class="fas fa-phone"></i>
              </span>
              @if (phoneControl.errors?.required) {
                <p class="help is-danger">Phone Number is required.</p>
              }
              @if (phoneControl.errors?.pattern) {
                <p class="help is-danger">Invalid Phone Number.</p>
              }
            </div>
          </div>
          <div class="field">
            <label class="label" for="zipCode">Zip Code</label>
            <div class="control has-icons-left">
              <input class="input" type="text" formControlName="zipCode" id="zipCode" [imask]="zipMask" autocomplete="postal-code">
              <span class="icon is-left">
                <i class="fas fa-map-marker-alt"></i>
              </span>
              @if (zipCodeControl.errors?.required) {
                <p class="help is-danger">Zip Code is required.</p>
              }
              @if (zipCodeControl.errors?.pattern) {
                <p class="help is-danger">Zip Code must be 5 digits.</p>
              }
            </div>
          </div>
        </div>
        <div class="field">
          <div class="control">
            <input type="hidden" formControlName="propertyType">
            <input type="hidden" formControlName="propertyUse">
            @if (lead.type === 'refinance' && veteranMilitaryControl.value === 'yes') {
              <input type="hidden" formControlName="currentVA">
            }
            @if (lead.type === 'refinance') {
              <input type="hidden" formControlName="currentFHA">
            }
            <input type="hidden" formControlName="email">
            @for (notification of notifications; track notification) {
              <div class="notification is-{{notification.type}} is-light">
                <button type="button" class="delete" aria-label="Dismiss notification" (click)="dismissNotification()"></button>
                {{notification.message}}
              </div>
            }
            <input type="hidden" name="universal_leadid" id="leadid_token" autocomplete="off" value="" />
            <button type="submit" class="button is-success is-fullwidth is-size-4 is-size-5-mobile has-text-weight-black has-shadow-large" [disabled]="! leadForm.valid || disableSubmit">Get Rates &#12297;</button>
          </div>
        </div>
        <div class="field">
          <p class="tcpa is-size-7 has-text-grey-dark">
            <input type="hidden" id="leadid_tcpa_disclosure_form">
            <label for="leadid_tcpa_disclosure_form">
              @if (lead.propertyState !== 'NY') {
                <span>*By entering my number and clicking the button above, I am electronically signing this web-form and giving my <strong>express written consent</strong> for FreeRateUpdate.com LLC and its <a href="/approved-lenders" target="_blank" rel="nofollow noopener noreferrer">network of lenders, mortgage brokers, and agents/assigns</a> that may call or text on behalf of those companies to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgage/home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of voice calls and SMS/MMS messages that are dialed manually or by using an automatic telephone dialing system, and prerecorded, artificial or AI-generated voice messages. Message and data rates may apply. I can call 855-315-7283 for help and text STOP to cancel. I acknowledge that consent is not required as a condition to utilize the services of FreeRateUpdate.com LLC or any of its network of lenders, mortgage brokers, and agents and that I may instead choose to use those services by calling 855-315-7283.</span>
              }
              @if (lead.propertyState === 'NY') {
                <span>*By entering my number and clicking the button above, I am electronically signing this web-form and giving my <strong>express written consent</strong> for FreeRateUpdate.com LLC, including its network members LoanDepot, Rocket Mortgage, <a href="/approved-lenders" target="_blank" rel="nofollow noopener noreferrer"> and other lenders, mortgage brokers, and agents/assigns</a> that may call or text on behalf of those companies to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgage/home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of voice calls and SMS/MMS messages that are dialed manually or by using an automatic telephone dialing system, and prerecorded, artificial or AI-generated voice messages. Message and data rates may apply. I can call 855-315-7283 for help and text STOP to cancel. I acknowledge that consent is not required as a condition to utilize the services of FreeRateUpdate.com LLC or any of its network of lenders, mortgage brokers, and agents and that I may instead choose to use those services by calling 855-315-7283.</span>
              }
              <br/><br/>
              I also agree to and am electronically signing FreeRateUpdate.com's <a href="/privacy" target="_blank" rel="nofollow noopener noreferrer">Privacy Policy</a> and its <a href="/terms" rel="nofollow noopener noreferrer" target="_blank">Terms and Conditions</a>.
            </label>
          </p>
          <p class="is-flex is-flex-centered">
            <img src="/assets/images/bbb-a-plus-rating.gif" alt="BBB A+ Rated">
          </p>
        </div>
      </div>
    </div>
  </form>
}
